import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'

interface Props {
  jours?: number
}

const JoursParAn = ({ jours }: Props) => {
  const description = jours ?? undefined

  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.france.jours_par_an')}
      description={description?.toString()}
    />
  )
}

export default JoursParAn
